import { DEFAULT_MENU_THEME } from "../config/menuThemes";
import { parsePersianNumber } from "../utils/persianNumber";

export const buildMenuSavePayload = ({ title, theme, categories = [] }) => ({
  title: title?.trim() || "",
  theme: theme || DEFAULT_MENU_THEME,
  categories: categories.map((category) => {
    const normalizedCategory = {
      name: category.name?.trim() || "",
      icon: category.icon || null,
      iconColor: category.iconColor || "#F88225",
      items: (category.items || []).map((item) => {
        const normalizedItem = {
          name: item.name?.trim() || "",
          price: parsePersianNumber(item.price) ?? 0,
          description: item.description?.trim() || "",
          image: item.image || "",
        };
        if (item._id) normalizedItem._id = item._id;
        return normalizedItem;
      }),
    };
    if (category._id) normalizedCategory._id = category._id;
    return normalizedCategory;
  }),
});

export const getPublicMenuPath = (menuLink) => (
  menuLink ? `/menu/${encodeURIComponent(menuLink)}` : null
);

export const mergeEditedMenuItem = (existingItem, changes) => ({
  ...changes,
  ...(existingItem?._id ? { _id: existingItem._id } : {}),
});
